import React from 'react'
import { SpecificationDiv } from './specification.styled.component'
import { Text } from '../../../'

export const SpecificationsComponent = ({ product }) => {

  return (
    <SpecificationDiv>
      {product?.dimension && (
        <div>
          <Text
            fontFamily=""
            fontWeight="bold"
            fontSize="15px"
            textId="produt-detail.title-format"
          />
          <label className='info'>{ product.dimension }</label>
        </div>
      )}
      {product?.dimensions && (
        <div>
          <Text
            fontFamily=""
            fontWeight="bold"
            fontSize="15px"
            textId="produt-detail.title-dimensions"
          />
          <label className='info'>{ product.dimensions }</label>
        </div>
      )}
      {product?.thickness && (
        <div>
          <Text
            fontFamily=""
            fontWeight="bold"
            fontSize="15px"
            textId="produt-detail.title-thickness"
          />
          <label className='info'>{ product.thickness }</label>
        </div>
      )}
      {product?.bevel && (
        <div>
          <Text
            fontFamily=""
            fontWeight="bold"
            fontSize="15px"
            textId="produt-detail.title-bevel"
          />
          <label className='info'>{ product.bevel }</label>
        </div>
      )}
      {product?.finish && (
        <div>
          <Text
            fontFamily=""
            fontWeight="bold"
            fontSize="15px"
            textId="produt-detail.title-finishing"
          />
          <label className='info'>{ product.finish }</label>
        </div>
      )}
      {product?.lockingSystem && (
        <div>
          <Text
            fontFamily=""
            fontWeight="bold"
            fontSize="15px"
            textId="produt-detail.title-locking"
          />
          <label className='info'>{ product.lockingSystem }</label>
        </div>
      )}
      {product?.classUse && (
        <div>
          <Text
            fontFamily=""
            fontWeight="bold"
            fontSize="15px"
            textId="produt-detail.title-class-of-use"
          />
          <label className='info'>{ product.classUse }</label>
        </div>
      )}
      {product?.warranty && (
        <div>
          <Text
            fontFamily=""
            fontWeight="bold"
            fontSize="15px"
            textId="produt-detail.title-warranty"
          />
          <label className='info'>{ product.warranty }</label>
        </div>
      )}
    </SpecificationDiv>
  )
};
